import PinExtension from "./en/PinExtension.js";
import SupportUs from "./en/SupportUs.js";
import Header from "./Header.js";
import { Link } from "react-router-dom";

export default function SpongeColorPicker(props){
    return(
        <>
        <Header title="Sponge Color Picker" x="35"/>
        <div className="article">
        Side panel eyedropper that supports all common color formats.<br /><br />

        Sponge Color Picker – Advanced Eyedropper & Color Tool
Enhance your workflow with Sponge Color Picker, the ultimate browser extension for designers, developers, and digital artists. Quickly grab, save, and copy colors from any webpage with precision and ease.
<br/><br/>
    <u>Key Features:</u>
<ul>
<li>Side Panel Support – Use seamlessly alongside your workspace.</li>
<li>Multi-Format Support – Hex, RGB, HSL, HSV, and CMYK output.</li>
<li>Auto-Copy – Samples are saved instantly and copied to your clipboard.</li>
<li>Magnifying Glass – Zoom in for pixel-perfect color selection.</li>
<li>Keyboard Controls – Move single pixels with arrow keys for accuracy.</li>
<li>Color Comparison tool – Match and compare colors with ease.</li>
<li>Palette Management – Move and save colors to a custom palette.</li>
<li>Text Simulation – Preview how colors affect readability and contrast.</li>
</ul>
<br/>
<u>Additional Configurable Features</u>:
<ul>
<li>Website Tracking – Automatically save the URL where the sample was taken.</li>
<li>Notes – So you won't forget.</li>
<li>Auto-Save – Your samples are preserved between sessions.</li>
<li>Multilingual Support – Available in 50+ languages.</li>
</ul><br/>
<p>Available for: <a href="https://chromewebstore.google.com/detail/sponge-color-picker/nhnnanjcbeljgeilkbkpicbiofkddhan" className="button-link">Chrome</a> <a href="https://microsoftedge.microsoft.com/addons/detail/sponge-color-picker/mjblfknpoojclpcbmhlkmhpdpgejjcmo" className="button-link">Edge</a>.</p>
        </div>
            <PinExtension lang="en" />
            <div id="tutorial" className="main-title"><p>User Guide</p></div>
            <div className="article">
                <p><h3 className="submenu">Top Bar</h3></p>
                <img src="../assets/sponge/ribbon.png"/>
                <p>
                <img src="../assets/sponge/sample.svg" height="20px" /> <b>Sample a Color</b> - Clicking this will change your mouse cursor to a magnifying glass,
                 click on the target to sample it. You can use the keyboard arrow keys to move a single pixel at a time.
                By default, the sampled color’s HEX value is automatically copied to the clipboard.
You can change this to a different color format or disable the auto-copy feature in Settings.<br />
<img src="../assets/sponge/undo.svg" height="20px" style={{marginTop:"8px"}} /> <b>Undo</b><br />
<img src="../assets/sponge/redo.svg" height="20px" style={{marginTop:"8px"}} /> <b>Redo</b> <br />
<img src="../assets/sponge/add-txt.svg" height="20px" style={{marginTop:"8px"}} /> <b>Add/Remove Text from Displayed Samples</b> - Toggles text overlay on color samples.
This helps designers evaluate how suitable the selected color is as a background for text.<br />
<img src="../assets/sponge/rows-mode.svg" height="20px" style={{marginTop:"8px"}} /> <img src="../assets/sponge/tiles-mode.svg" height="20px"/> <b>Samples Display Mode</b> - Switch between the two samples viewing modes: Tiles view or Rows view.<br />
<img src="../assets/sponge/settings.svg" height="20px" style={{marginTop:"8px"}} /> <b>Settings</b> - Opens the Settings menu.<br />
&nbsp;&nbsp;<img src="../assets/sponge/more.svg" height="20px" style={{marginTop:"8px"}} />&nbsp; <b>More</b> - Opens a dropdown menu where you will find an option to delete all samples as well as a link to contact us.
                </p>
<p><h3 className="submenu">Samples View</h3></p>
                <p>
In Tiles view, samples appear as colored squares in the lower part of the view.
Clicking a square selects it, and the selected sample appears in the upper part of the view in a larger square called the Color display.<br /><br />

Both Rows view and Tiles view upper part of the interface can, depending on your settings, display:
<br /><ul>
    <li>The color in various text format representations (HEX, RGB, HSL, etc.).</li>
    <li>A field for your notes.</li>
    <li>A link to the URL where the color was sampled.</li>
</ul>

You can also adjust the color of the sample by clicking on the color rectangle in the Rows view or the Color display in the Tiles view.<br />
The samples colors text representation are buttons, clicking on them will copy the text to the clipboard.<br /><br />

<b>Notes:</b> <br />
<ul>
    <li> By default, when taking a sample the HEX format of the sample is automatically saved to the clipboard, you can change this behavior in the settings.</li>
    <li>For a sample to include a URL, the “Capture URL” setting must be enabled before taking the sample.
Additionally, the “Display URL” option must be enabled.</li>
</ul>
 </p>           
<p><h3 className="submenu">Additional Features in Tiles view mode:</h3></p>
            <p>
If you want to see how your selected samples pair with another color, you can do this by pressing the small square above the corner of the Color display and choosing a color. To change how the colors are compared (side by side, a line in the background etc.) press the other little square above the color display, on each press the comparison mode will change. <br /><br />
You can also manage your color palette:
<ul>
    <li>To add a color to your palette, click the arrow next to the Color Display.</li>
    <li>To change a color's position in the palette, press on it and don't release. Drag the color to its new position and then release.</li>
    <li>To remove a single color, hover over it in the palette and click the X icon.</li>
    <li>To clear the entire palette, click the trash icon above the palette.</li>
    </ul>






            </p>
            
            </div>
                   
            <SupportUs />
        </>
        )
}